import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CategoryDetailsPageContext } from "@insite/content-library/Pages/CategoryDetailsPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryDetailBannerStyles {
    container?: InjectableCss;
}

export const bannerStyles: CategoryDetailBannerStyles = {
    container: {
        css: css`
            p {
                font-size: 14px; // Remove if have same size in style guide
                line-height: normal !important;
                text-align: center;
                width: 75%;
                margin: auto;
                a {
                    text-decoration: underline;
                    span{
                        color: ${getColor("text.main")} !important;
                    }
                }
            }
        `,
    },
};

const styles = bannerStyles;

const CategoryDetailBanner = ({ category }: Props) => {
    if (!category || !category.htmlContent) {
        return null;
    }

    return <StyledWrapper {...styles.container}>{parse(category.htmlContent, parserOptions)}</StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailBanner),
    definition: {
        group: "Categories",
        icon: "Banner",
        allowedContexts: [CategoryDetailsPageContext],
    },
};

export default widgetModule;
